import React from 'react';
import { useSelector } from 'react-redux';
import { useFieldArray } from 'react-final-form-arrays';

import { Advice } from 'types/Checklist';
import FormKeys from 'modules/form/types/FormKeys';
import { AbstractMedia } from 'types/AbstractMedia';

import { createDictionary } from 'utils/objectUtils';
import { useGetSelfServiceByIdQuery } from 'modules/selfServices/service';
import { getAdvices, GetAdvicesFunc, getExtras, getProactiveWorks } from 'modules/selfServices/utils';

import { getSelectedSelfServiceId } from 'modules/auth/selectors';

import AdviceCard from './AdviceCard';

export type AdvicesProps = {
  name: string,
  formKey: FormKeys,
  mediaPlaceholder?: AbstractMedia
};

export const getAdvicesFunctions = createDictionary<FormKeys, GetAdvicesFunc>({
  [FormKeys.EXTRAS]: getExtras,
  [FormKeys.REPAIR_ORDER]: getProactiveWorks,
}, getAdvices);

const Advices: React.FC<AdvicesProps> = ({ name, formKey, mediaPlaceholder }) => {
  const selfServiceId = useSelector(getSelectedSelfServiceId);

  const { data } = useGetSelfServiceByIdQuery({ id: selfServiceId });
  const originalAdvices = React.useMemo(() => getAdvicesFunctions[formKey](data), [data, formKey]);

  const { fields: advices } = useFieldArray<Advice>(name, { subscription: {} });

  return advices.map((extraName: string) => (
    <li key={extraName} >
      <AdviceCard name={extraName} advices={originalAdvices} mediaPlaceholder={mediaPlaceholder} />
    </li>
  ));
};

export default Advices;
